import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import Preloader from "../../components/Preloader";
import NetworkError from "../../components/NetworkError";
import { textes } from "../../constants/textes";
import { config } from "../../constants/config";
import Pagination from "../../components/Pagination";
import Select from "react-select";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Cash, Clock, PersonWorkspace, TextParagraph, Wifi } from "react-bootstrap-icons";
import imageCompression from "browser-image-compression";
import Forfait from "./forfait";
import Search from "../Search";

export default function Forfaits() {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [compressing, setCompressin] = useState(false);
    const [error, setError] = useState(false);
    const [addstate, setAddstate] = useState(false);

    const [fetching, setFetching] = useState(false);

    const [elementsList, setElementsList] = useState([]);
    const [nbpage, setNbpage] = useState(1);
    const [nbelement, setNbelement] = useState(0);
    const [page, setPage] = useState(0);

    const [isSearch, setIsSearch] = useState(false);
    const [chaine, setChaine] = useState('');

    const [lib, setlib] = useState("");
    const [profile, setprofile] = useState("");
    const [desc, setdesc] = useState("");
    const [duree, setduree] = useState("");
    const [prix, setprix] = useState("");
    const [nbposte, setnbposte] = useState("");
    const [qte, setqte] = useState("");
    const [qtejour, setqtejour] = useState("");
    const [uniteqte, setuniteqte] = useState("");
    const [uniteqtejour, setuniteqtejour] = useState("");
    const [typeforfait, settypeforfait] = useState('');
    const [typeforfaitsList, settypeforfaitsList] = useState([]);
    const [hotspot, sethotspot] = useState('');
    const [hotspotsList, sethotspotsList] = useState([]);
    const [site, setsite] = useState('');
    const [sitesList, setsitesList] = useState([]);
    const [revendeur, setrevendeur] = useState('');
    const [revendeursList, setrevendeursList] = useState([]);
    const [picture, setPicture] = useState('');
    const [pictureprev, setPictureprev] = useState('/assets/imgs/no-image.png');

    const [unite, setUnite] = useState({label: "Jour (s)", value: "days"});

    const unites = [
        {
            label: "Heure (s)",
            value: "Hours",
        },
        {
            label: "Jour (s)",
            value: "days",
        },
    ];

    const unitedatas = [
        {
            label: "Go",
            value: 0,
        },
        {
            label: "Mo",
            value: 1,
        },
    ];

    const paksList = [
        {
            label: "Y-Hour",
            value: "0",
            duree: "1"
        },
        {
            label: "Y-Hour-Light",
            value: "10",
            duree: "1"
        },
        {
            label: "Y-Hour-Soft",
            value: "20",
            duree: "1"
        },
        {
            label: "Y-Day",
            value: "1",
            duree: "1"
        },
        {
            label: "Y-Day-Light",
            value: "11",
            duree: "1"
        },
        {
            label: "Y-Day-Soft",
            value: "111",
            duree: "1"
        },
        {
            label: "Y-3Days",
            value: "3",
            duree: "3"
        },
        {
            label: "Y-3Days-Light",
            value: "33",
            duree: "3"
        },
        {
            label: "Y-3Days-Soft",
            value: "333",
            duree: "3"
        },
        {
            label: "Y-Week",
            value: "7",
            duree: "7"
        },
        {
            label: "Y-Week-Light",
            value: "77",
            duree: "7"
        },
        {
            label: "Y-Week-Soft",
            value: "777",
            duree: "7"
        },
        {
            label: "Y-Month",
            value: "30",
            duree: "30"
        },
        {
            label: "Y-Month-Light",
            value: "301",
            duree: "30"
        },
        {
            label: "Y-Month-Soft",
            value: "302",
            duree: "30"
        },
    ];


    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const showWarningMessage = (msg) => {
        toast.warning(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const getElementsList = async (p) => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        if (user?.isFullAction || user.isAdminAction) {
            await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/bundles?limit=${config.app.limit}&page=${p + 1}&etat=1,2,3,4,5,6,7,8,9,10`, requestOptions).then((response) => {
                if (response?.status === 200) {
                    response.json().then(async (data) => {
                        // console.log("resonse jsondecode", data?.body?.data);
                        if (data?.head) {
                            let clientarray = [];
    
                            clientarray = data?.body?.data;
    
                            setElementsList(clientarray);
                            setNbpage(data?.body?.pages);
                            setNbelement(data?.body?.length);
                            setLoading(false);
                        } else {
                            if (data?.body?.data?.msg === "expiredsession") {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                setError(true);
                                setLoading(false);
                            }
                        }
                    });
                } else if (response?.status === 401) {
                    logoutUser();
                    navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                } else {
                    setError(true);
                    setLoading(false);
                }
    
            }).catch((err) => {
                // console.log("error", err);
                setError(true);
                setLoading(false);
            });
        } else {
            await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/bundles?limit=${config.app.limit}&page=${p + 1}&coderevendeur=${user?.codeutilisateur}&etat=1,2,3,4,5,6,7,8,9`, requestOptions).then((response) => {
                if (response?.status === 200) {
                    response.json().then(async (data) => {
                        // console.log("resonse jsondecode", data?.body?.data);
                        if (data?.head) {
                            let clientarray = [];
    
                            clientarray = data?.body?.data;
    
                            setElementsList(clientarray);
                            setNbpage(data?.body?.pages);
                            setNbelement(data?.body?.length);
                            setLoading(false);
                        } else {
                            if (data?.body?.data?.msg === "expiredsession") {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                setError(true);
                                setLoading(false);
                            }
                        }
                    });
                } else if (response?.status === 401) {
                    logoutUser();
                    navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                } else {
                    setError(true);
                    setLoading(false);
                }
    
            }).catch((err) => {
                // console.log("error", err);
                setError(true);
                setLoading(false);
            });
        }
    }

    const autoSearchElement = async (c) => {
        setPage(0);
        if ((c && !isSearch) || (c && isSearch)) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
            myHeaders.append("token", config.app.PUBLICKEY);
            myHeaders.append("apikey", user.token);
            myHeaders.append("cpte", user.code);
            myHeaders.append("prof", user.profil);
            myHeaders.append("conn", user.espace);


            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
                // body: urlencoded,
                redirect: 'follow'
            };

            // console.log("data send", urlencoded)

            await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/bundles?crit=${c}&etat=1,2,3,4,5,6,7,8,9`, requestOptions).then((response) => {
                if (response?.status === 200) {
                    response.json().then(async (data) => {
                        if (data?.head) {
                            // console.log("resonse jsondecode", data);
                            let clientarray = [];
                            clientarray = data?.body?.data;

                            setElementsList(clientarray);
                            setNbpage(data?.body?.pages);
                            setNbelement(data?.body?.length);
                            // setLoading(false);
                        } else {
                            if (data?.body?.data?.msg === "expiredsession") {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                setError(true);
                            }
                            // setLoading(false);
                        }
                    });
                } else if (response?.status === 401) {
                    logoutUser();
                    navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                } else {
                    setError(true);
                    // setLoading(false);
                }

            }).catch((err) => {
                // console.log("error", err);
                setError(true);
                // setLoading(false);
            });
        } else if (c !== "" && isSearch) {
            setIsSearch(false);
            getElementsList(page);
        } else {
            setIsSearch(false);
            getElementsList(page);
        }
    }

    const getTypeForfaitsList = async () => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.domain.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)
        await fetch(`${config.domain.BASE_URL}/${config.domain.PROJECT}/nouns?nomtab=tforfait`, requestOptions).then((response) => {

            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            clientarraydata.push({ label: element.lib, value: element.code });
                        });


                        settypeforfaitsList(clientarraydata);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("get departement list", "error")
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("get staut erreur", "error");
            }

        }).catch((err) => {
            console.log("error get tforfait list", err);
            // setError(true);
            // setLoading(false);
        });
    }

    const getRevendeursList = async () => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/users?type=revendeur&etat=1,2,3,4,5,6,7,8,9`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            
                            // if (element.abrevtypeutilisateur === "RVD") {
                            //     clientarraydata.push({ label: element.nom + " " + element.prenom, value: element.code });
                            // }
                            clientarraydata.push({ label: element.nom + " " + element.prenom, value: element.codeutilisateur });

                        });

                        setrevendeursList(clientarraydata);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("server error", err);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("statut error", err);
            }

        }).catch((err) => {
            console.log("error get reventeurs list", err);
            // setError(true);
            // setLoading(false);
        });
    }

    const getSiteList = async (prevendeur) => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/sites?coderevendeur=${prevendeur}&etat=2`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            clientarraydata.push({ label: element.nom, value: element.code });
                        });


                        setsitesList(clientarraydata);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("server error", err);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("statut error", err);
            }

        }).catch((err) => {
            // console.log("error get client list", err);
            // setError(true);
            // setLoading(false);
        });
    }

    const getSiteList2 = async () => {

        if (!user?.isFullAction && !user?.isAdminAction) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
            myHeaders.append("token", config.app.PUBLICKEY);
            myHeaders.append("apikey", user.token);
            myHeaders.append("cpte", user.code);
            myHeaders.append("prof", user.profil);
            myHeaders.append("conn", user.espace);

            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
                // body: urlencoded,
                redirect: 'follow'
            };

            // console.log("data send", urlencoded)

            await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/sites?coderevendeur=${user?.codeutilisateur}&etat=2`, requestOptions).then((response) => {
                if (response?.status === 200) {
                    response.json().then(async (data) => {
                        // console.log("resonse jsondecode", data);
                        if (data?.head) {
                            let clientarray = [];

                            clientarray = data?.body?.data;

                            let clientarraydata = [];
                            await clientarray.forEach(element => {
                                clientarraydata.push({ label: element.nom, value: element.code });
                            });


                            setsitesList(clientarraydata);
                        } else {
                            if (data?.body?.data?.msg === "expiredsession") {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // console.log("server error", err);
                            }
                        }
                    });
                } else if (response?.status === 401) {
                    logoutUser();
                    navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                } else {
                    // console.log("statut error", err);
                }

            }).catch((err) => {
                // console.log("error get client list", err);
                // setError(true);
                // setLoading(false);
            });
        }

    }

    const getHotspotsList = async (psite) => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/hotspots?codesite=${psite}&etat=1,2`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            clientarraydata.push({ label: element.lib, value: element.code });
                        });


                        sethotspotsList(clientarraydata);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("server error", err);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("statut error", err);
            }

        }).catch((err) => {
            // console.log("error get client list", err);
            // setError(true);
            // setLoading(false);
        });
    }

    const handlepicturechange = (e) => {
        const file = e.target.files[0];
        setPicture(file)
        TransformPicture(file);
        // console.log("recto prev", rectoprev)
    };

    const TransformPicture = async (file) => {
        const reader = new FileReader();

        const options = {
            maxSizeMB: config.app.maxsizefileoption,
            maxWidthOrHeight: 500,
            useWebWorker: true
        };

        if (file) {
            if (file.size > config.app.maxsizefile * 1024) {
                setCompressin(true);
                await imageCompression(file, options).then((img) => {
                    reader.readAsDataURL(img);
                    reader.onloadend = () => {
                        setPictureprev(reader.result);
                    };
                });
                setCompressin(false);
            } else {
                reader.readAsDataURL(file);
                reader.onloadend = () => {
                    setPictureprev(reader.result);
                };
            }

        } else {
            setPictureprev("/assets/imgs/no-image.png");
        }
    };


    // comportements
    useEffect(() => {
        getElementsList(page);
        getTypeForfaitsList();
        getRevendeursList();
        getSiteList2();
    }, []);

    useEffect(() => {
        const stimeout = setTimeout(() => {
            autoSearchElement(chaine);
        }, 1000);

        return () => clearTimeout(stimeout);
    }, [chaine]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        setFetching(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var urlencoded = new URLSearchParams();
        if (lib) urlencoded.append("lib", lib);
        if (desc) urlencoded.append("descr", desc);
        if (profile) urlencoded.append("prof", profile["label"]);
        if (prix) urlencoded.append("prix", prix);
        if (duree && unite) urlencoded.append("duree", duree + " " + unite["value"]);
        if (qte) urlencoded.append("qte", qte + " " + uniteqte["label"]);
        if (qte) urlencoded.append("qtekilo", uniteqte["label"] === "Go" ? qte * 1073741824 : qte * 1048576);
        if (nbposte) urlencoded.append("nbposte", nbposte);
        if (qtejour) urlencoded.append("qtelimitjour", qtejour + " " + uniteqtejour["label"]);
        if (qtejour) urlencoded.append("qtelimitjourkilo", uniteqtejour["label"] === "Go" ? qtejour * 1073741824 : qtejour * 1048576);
        if (typeforfait) urlencoded.append("codetforfait", typeforfait["value"]);
        if (hotspot) urlencoded.append("codehotspot", hotspot["value"]);
        if (picture) urlencoded.append("img", pictureprev);
        urlencoded.append("defaut", false);
        urlencoded.append("edit", true);
        urlencoded.append("etatdef", "En service");

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: urlencoded,
            redirect: "follow",
        };

        // console.log("data send", urlencoded)

        await fetch(
            `${config.app.BASE_URL}/${config.app.PROJECT}/bundles`,
            requestOptions
        ).then((response) => {
            if (response?.status === 200 || response?.status === 201) {
                response.json().then(async (data) => {
                    // console.log("resonse ajout droit", data);
                    if (!data?.head) {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        }  else {
                            setFetching(false);
                            showErrorMessage(data?.body?.data?.msg);
                        }
                    } else {
                        showSuccesMessage(textes.fr.forfaitaddedlabel);
                        setAddstate(false);
                        getElementsList(page);
                        setlib("");
                        setprofile("");
                        setdesc("");
                        setduree("");
                        setprix("");
                        settypeforfait("");
                        setPicture("");
                        setPictureprev('/assets/imgs/no-image.png');
                        // setUnite("");
                        setnbposte("");
                        setqte("");
                        setqtejour("");
                        setuniteqte("");
                        setuniteqtejour("");
                        sethotspot("");
                        setsite("");
                        setrevendeur("");
                        setFetching(false);
                    }

                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("resonse ", response);
                // setError(true);
                showErrorMessage(textes.fr.serviceunavaillable);
                setFetching(false);
            }
        }).catch((err) => {
            // console.log("error", err);
            // setError(true);
            showErrorMessage(textes.fr.serviceunavaillable);
            setFetching(false);
        });
    };


    // affichages
    return (
        <div className="row">
            <div className="col-md-12">
                {loading && <Preloader />}
                {!loading && error && <NetworkError />}
                {!loading && !error && (
                    <div
                        className="col-md-12"
                        style={{
                            paddingTop: 8,
                            borderTop: "1px solid #ddd",
                            borderRadius: 8,
                        }}
                    >
                        <div className="row">
                            <div className="col-md-12 mb-3">
                                <Search
                                    chaine={chaine}
                                    setChaine={setChaine}
                                    // search={searchEmployee}
                                    placeholder="Rechercher..."
                                />
                            </div>
                            <div className="col-md-12 mb-3">
                                <div className="card shadow mb-4">
                                    <div className="card-header py-3">
                                        {!addstate && (
                                            <button
                                                data-toggle="tooltip"
                                                title={textes.fr.newforfaitlabel}
                                                onClick={() => setAddstate(true)}
                                                data-placement="left"
                                                className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                            >
                                                <i className="fa fa-plus mr-1"></i>{" "}
                                                <span>{textes.fr.newforfaitlabel}</span>
                                            </button>
                                        )}
                                        <h6 className="m-0 ">
                                            {addstate
                                                ? textes.fr.forfaitinfoslabel
                                                : textes.fr.listforfaitlabel}
                                        </h6>
                                    </div>
                                    {!addstate && (
                                        <div className="card-body">
                                            <div className="table-responsive mb-3">
                                                <table className="mb-0 table table-bordered">
                                                    <thead className="bg-primary">
                                                        <tr className="bg-primary text-white">
                                                            <th className="text-center">#</th>
                                                            <th>Hotspot</th>
                                                            <th>Forfait</th>
                                                            <th>Durée</th>
                                                            <th>Données</th>
                                                            <th>Prix</th>
                                                            <th>{textes.fr.statelabel}</th>
                                                            <th>{textes.fr.addeddatelabel}</th>
                                                            <th className="text-center">
                                                                {textes.fr.actionlabel}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {elementsList.length === 0 && (
                                                            <tr style={{ borderStyle: "none" }}>
                                                                <th colSpan={9} className="text-center">
                                                                    {textes.fr.noforfaitfound}
                                                                </th>
                                                            </tr>
                                                        )}
                                                        {elementsList.length > 0 &&
                                                            elementsList?.map((item, index) => (
                                                                <Forfait
                                                                    forfait={item}
                                                                    position={(config.app.limit * page) + index}
                                                                    key={index}
                                                                />
                                                            ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <Pagination
                                                nbpage={nbpage}
                                                getList={getElementsList}
                                                page={page}
                                                setPage={setPage}
                                            />
                                        </div>
                                    )}
                                    {addstate && (
                                        <div className="card-body">
                                            <form style={{ width: "100%" }} onSubmit={handleSubmit}>
                                                <div className="row">
                                                    <div className="col-md-12 mb-3">
                                                        <div className="row">
                                                            <div className="col-md-4 mb-3">
                                                                <div className="row">
                                                                    <div className="col-md-12 mb-2">
                                                                        <label htmlFor="logo" className="form-label">Image illustrative</label>
                                                                        <input className="form-control" type="file" id="logo" onChange={handlepicturechange} />
                                                                    </div>
                                                                    {compressing && <div className="col-md-12 p-5 mb-3">
                                                                        <Spinner
                                                                            as="span"
                                                                            animation="border"
                                                                            size="lg"
                                                                            role="status"
                                                                            aria-hidden="true"
                                                                            style={{ display: "block", marginLeft: 'auto', marginRight: 'auto' }}
                                                                        />
                                                                    </div>}
                                                                    {!compressing && <div className="col-md-12 mb-3">
                                                                        <img alt="" src={pictureprev} className={`rounded `} style={{ width: "100%", border: "1px solid" }} />
                                                                    </div>}
                                                                </div>
                                                            </div>
                                                            <div className="col-md-8 mb-3">
                                                                <div className="row">
                                                                    {(user?.isFullAction || user?.isAdminAction) && <div className="col-md-12 mb-3">
                                                                        <label htmlFor="revendeur" className="mb-1">
                                                                            {textes.fr.revendeurlabel}
                                                                        </label>
                                                                        <Select
                                                                            id="revendeur"
                                                                            name="revendeur"
                                                                            placeholder={textes.fr.selectlabel}
                                                                            options={revendeursList}
                                                                            value={revendeur}
                                                                            onChange={(selected) => {
                                                                                setrevendeur(selected);
                                                                                if (selected) {
                                                                                    getSiteList(selected["value"]);
                                                                                } else {
                                                                                    setsitesList([]);
                                                                                    sethotspotsList([]);
                                                                                    setsite("");
                                                                                    sethotspot("");
                                                                                }
                                                                                
                                                                            }}
                                                                            isClearable
                                                                        />
                                                                    </div>}
                                                                    <div className="col-md-4 mb-3">
                                                                        <label htmlFor="site" className="mb-1">
                                                                            {textes.fr.sitelabel}
                                                                        </label>
                                                                        <Select
                                                                            id="site"
                                                                            name="site"
                                                                            placeholder={textes.fr.selectlabel}
                                                                            options={sitesList}
                                                                            value={site}
                                                                            onChange={(selected) => {
                                                                                setsite(selected);
                                                                                if (selected) {
                                                                                    getHotspotsList(selected["value"]);
                                                                                } else {
                                                                                    sethotspotsList([]);
                                                                                    sethotspot("");
                                                                                }
                                                                                
                                                                            }}
                                                                            isClearable
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-4 mb-3">
                                                                        <label htmlFor="hotspot" className="mb-1">
                                                                            {textes.fr.hotspotlabel}
                                                                        </label>
                                                                        <Select
                                                                            id="hotspot"
                                                                            name="hotspot"
                                                                            placeholder={textes.fr.selectlabel}
                                                                            options={hotspotsList}
                                                                            value={hotspot}
                                                                            onChange={(selected) => {
                                                                                sethotspot(selected);
                                                                            }}
                                                                            isClearable
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-4 mb-3">
                                                                        <label htmlFor="typeforfait" className="mb-1">
                                                                            {textes.fr.typeforfaitlabel}
                                                                        </label>
                                                                        <Select
                                                                            id="typeforfait"
                                                                            name="typeforfait"
                                                                            placeholder={textes.fr.selectlabel}
                                                                            options={typeforfaitsList}
                                                                            value={typeforfait}
                                                                            onChange={(selected) => {
                                                                                settypeforfait(selected);
                                                                            }}
                                                                            isClearable
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-6 mb-3">
                                                                        <label htmlFor="lib" className="mb-1">
                                                                            Libelle
                                                                        </label>
                                                                        <div className="input-group flex-nowrap">
                                                                            <span
                                                                                className="input-group-text"
                                                                                id="lib"
                                                                            >
                                                                                <TextParagraph />
                                                                            </span>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                placeholder={textes.fr.entervaluelabel}
                                                                                value={lib}
                                                                                onChange={(e) =>
                                                                                    setlib(e.target.value)
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6 mb-3">
                                                                        <label htmlFor="profile" className="mb-1">Profile</label>
                                                                        <Select
                                                                            id="profile"
                                                                            name="profile"
                                                                            placeholder={textes.fr.selectlabel}
                                                                            options={paksList}
                                                                            value={profile}
                                                                            onChange={(selected) => {
                                                                                setprofile(selected);
                                                                                if (selected !== null) {
                                                                                    setduree(selected["duree"]);
                                                                                    setUnite((selected["value"] === "0" || selected["value"] === "10" || selected["value"] === "20") ? {label: "Heure (s)", value:"hours"} : {label: "Jour (s)", value: "days"});
                                                                                } else {
                                                                                    setduree("");
                                                                                    setUnite("");
                                                                                }
                                                                            }}
                                                                            isClearable
                                                                        />
                                                                    </div>
                                                                    {/* <div className="col-md-6 mb-3">
                                                                        <label htmlFor="profile" className="mb-1">
                                                                            Profile
                                                                        </label>
                                                                        <div className="input-group flex-nowrap">
                                                                            <span
                                                                                className="input-group-text"
                                                                                id="profile"
                                                                            >
                                                                                <CardText />
                                                                            </span>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                placeholder={textes.fr.entervaluelabel}
                                                                                value={profile}
                                                                                onChange={(e) =>
                                                                                    setprofile(e.target.value)
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div> */}
                                                                    <div className="col-md-4 mb-3">
                                                                        <label htmlFor="prix" className="mb-1">
                                                                            Prix
                                                                        </label>
                                                                        <div className="input-group flex-nowrap">
                                                                            <span
                                                                                className="input-group-text"
                                                                                id="prix"
                                                                            >
                                                                                <Cash />
                                                                            </span>
                                                                            <input
                                                                                type="number"
                                                                                min={0}
                                                                                className="form-control"
                                                                                placeholder={textes.fr.entervaluelabel}
                                                                                value={prix}
                                                                                onChange={(e) => { setprix(e.target.value) }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4 mb-3">
                                                                        <label htmlFor="duree" className="mb-1">
                                                                            {textes.fr.durelabel}
                                                                        </label>
                                                                        <div className="input-group flex-nowrap">
                                                                            <span
                                                                                className="input-group-text"
                                                                                id="duree"
                                                                            >
                                                                                <Clock />
                                                                            </span>
                                                                            <input
                                                                                type="number"
                                                                                className="form-control"
                                                                                placeholder="Entrez la durée"
                                                                                value={duree}
                                                                                onChange={(e) =>
                                                                                    setduree(e.target.value)
                                                                                }
                                                                                disabled={(unite !== null && unite["value"] === "days") ? true : false}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4 mb-3">
                                                                        <label htmlFor="unite" className="mb-1">
                                                                            Unité
                                                                        </label>
                                                                        <Select
                                                                            id="unite"
                                                                            name="unite"
                                                                            placeholder="Sélectionner l'unité"
                                                                            options={unites}
                                                                            value={unite}
                                                                            onChange={(selected) => {
                                                                                setUnite(selected);
                                                                            }}
                                                                            isDisabled
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-6 mb-3">
                                                                        <label htmlFor="qte" className="mb-1">Quantité de données</label>
                                                                        <div className="input-group flex-nowrap">
                                                                            <span
                                                                                className="input-group-text"
                                                                                id="qte"
                                                                            >
                                                                                <Wifi />
                                                                            </span>
                                                                            <input
                                                                                type="number"
                                                                                className="form-control"
                                                                                placeholder="Entrez la durée"
                                                                                value={qte}
                                                                                onChange={(e) =>
                                                                                    setqte(e.target.value)
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6 mb-3">
                                                                        <label htmlFor="uniteqte" className="mb-1">
                                                                            Unité
                                                                        </label>
                                                                        <Select
                                                                            id="uniteqte"
                                                                            name="uniteqte"
                                                                            placeholder="Sélectionner l'unité"
                                                                            options={unitedatas}
                                                                            value={uniteqte}
                                                                            onChange={(selected) => {
                                                                                setuniteqte(selected);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    {/* <div className="col-md-6 mb-3">
                                                                        <label htmlFor="qtejour" className="mb-1">Quantité de données limite par jour</label>
                                                                        <div className="input-group flex-nowrap">
                                                                            <span
                                                                                className="input-group-text"
                                                                                id="qtejour"
                                                                            >
                                                                                <Wifi />
                                                                            </span>
                                                                            <input
                                                                                type="number"
                                                                                className="form-control"
                                                                                placeholder="Entrez la durée"
                                                                                value={qtejour}
                                                                                onChange={(e) =>
                                                                                    setqtejour(e.target.value)
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6 mb-3">
                                                                        <label htmlFor="uniteqte" className="mb-1">
                                                                            Unité
                                                                        </label>
                                                                        <Select
                                                                            id="uniteqte"
                                                                            name="uniteqte"
                                                                            placeholder="Sélectionner l'unité"
                                                                            options={unitedatas}
                                                                            value={uniteqtejour}
                                                                            onChange={(selected) => {
                                                                                setuniteqtejour(selected);
                                                                            }}
                                                                        />
                                                                    </div> */}
                                                                    <div className="col-md-12 mb-3">
                                                                        <label htmlFor="nbposte" className="mb-1">Nombre de poste autorisé</label>
                                                                        <div className="input-group flex-nowrap">
                                                                            <span
                                                                                className="input-group-text"
                                                                                id="nbposte"
                                                                            >
                                                                                <PersonWorkspace />
                                                                            </span>
                                                                            <input
                                                                                type="number"
                                                                                min={0}
                                                                                className="form-control"
                                                                                placeholder={textes.fr.entervaluelabel}
                                                                                value={nbposte}
                                                                                onChange={(e) =>
                                                                                    setnbposte(e.target.value)
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-12 mb-3">
                                                                        <label htmlFor="desc" className="mb-1">
                                                                            Description
                                                                        </label>
                                                                        <div className="input-group flex-nowrap">
                                                                            <span
                                                                                className="input-group-text"
                                                                                id="desc"
                                                                            >
                                                                                <TextParagraph />
                                                                            </span>
                                                                            <textarea
                                                                                className="form-control"
                                                                                placeholder={
                                                                                    textes.fr.descriptionlabel
                                                                                }
                                                                                value={desc}
                                                                                style={{ height: 154 }}
                                                                                onChange={(e) =>
                                                                                    setdesc(e.target.value)
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mt-2">
                                                        <button
                                                            type="submit"
                                                            title={textes.fr.newforfaitlabel}
                                                            className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                                            disabled={
                                                                typeforfait["value"] && lib && profile && duree && prix
                                                                    ? false
                                                                    : true
                                                            }
                                                        >
                                                            <i className="fa fa-check mr-2"></i>
                                                            <span>Valider</span>{" "}
                                                            {fetching && (
                                                                <Spinner
                                                                    as="span"
                                                                    animation="border"
                                                                    size="sm"
                                                                    role="status"
                                                                    aria-hidden="true"
                                                                />
                                                            )}
                                                        </button>
                                                        <button
                                                            onClick={() => {
                                                                setAddstate(false);
                                                                getElementsList(page);
                                                                setlib("");
                                                                setprofile("");
                                                                setdesc("");
                                                                setduree("");
                                                                setprix("");
                                                                settypeforfait("");
                                                                setPicture("");
                                                                setPictureprev('/assets/imgs/no-image.png');
                                                                // setUnite("");
                                                                setnbposte("");
                                                                setqte("");
                                                                setqtejour("");
                                                                setuniteqte("");
                                                                setuniteqtejour("");
                                                                sethotspot("");
                                                                setsite("");
                                                                setrevendeur("");
                                                            }}
                                                            title={textes.fr.cancel}
                                                            className="btn-shadow ml-3 btn btn-danger btn-sm float-right"
                                                        >
                                                            <i className="fa fa-reply mr-1"></i>{" "}
                                                            <span>{textes.fr.cancel}</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
